import script from "./ClientApp.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientApp.vue?vue&type=script&setup=true&lang=ts"

import "./ClientApp.vue?vue&type=style&index=0&id=6957daca&lang=scss"

const __exports__ = script;

export default __exports__